// Adresse und Optionen für EventSource-Dauerverbindungen (Realtime, Telefonie).
//
// Im Dev-Server spricht der Browser HTTP/1.1 und erlaubt nur sechs gleichzeitige
// Verbindungen je Host:Port. Jeder offene KMVS-Tab hält zwei Dauerverbindungen —
// ab dem dritten Tab blieben deshalb ALLE weiteren API-Aufrufe hängen. Ist
// `VITE_SSE_BASE` gesetzt (nur lokal, z. B. http://localhost:3001 — der
// Nebenport aus vite.config.ts), laufen die Dauerverbindungen über einen eigenen
// Port mit eigenem Verbindungskontingent. Ohne die Variable (DEV/PROD hinter
// nginx mit HTTP/2) bleibt alles wie bisher.
const SSE_BASE = ((import.meta.env.VITE_SSE_BASE as string | undefined) ?? "").replace(/\/$/, "");

export function oeffneEventSource(url: string): EventSource {
  if (!SSE_BASE || !url.startsWith("/")) return new EventSource(url);
  return new EventSource(SSE_BASE + url, { withCredentials: true });
}
